export enum Illumination {
  U3500 = 0,
  U3000 = 1,
  D65 = 2,
  CWF = 3,
  INCA_A10 = 4,
  TL83 = 5,
  TL84 = 6,
  UV = 7,
}

export const IlluminationLabels: Record<Illumination, string> = {
  [Illumination.U3500]: 'U3500',
  [Illumination.U3000]: 'U3000',
  [Illumination.D65]: 'D65',
  [Illumination.CWF]: 'CWF',
  [Illumination.INCA_A10]: 'INCA A10',
  [Illumination.TL83]: 'TL83',
  [Illumination.TL84]: 'TL84',
  [Illumination.UV]: 'UV',
};
